export default __webpack_public_path__ + "static/warning-messages-body-dont-1ca27fb3ebbe90e98eaece2b5b43970bb3a0ed578c094da46f6f9c542635e78e.png";